import i18n from "@/i18n";

export default {
  emptyField: [(v) => !!v || i18n.t("errorFrontEnd.requiredField")],
  inputText: [
    (v) =>
      /^[ A-Za-z0-9/-ÉÊÈÀÊÂÔÇéêèàêâôç-]*$/.test(v) ||
      i18n.t("errorFrontEnd.specialCharacters"),
  ],
  inputTextRequired: [
    (v) => !!v || i18n.t("errorFrontEnd.requiredField"),
    (v) =>
      /^[ A-Za-z0-9/-ÉÊÈÀÊÂÔÇéêèàêâôç-]*$/.test(v) ||
      i18n.t("errorFrontEnd.specialCharacters"),
  ],
  inputNumber: [
    (v) => /^[0-9]*$/.test(v) || i18n.t("crudRooms.errorInvalidNumber"),
  ],
  inputEmail: [
    (v) => !!v || i18n.t("errorFrontEnd.requiredField"),
    (v) =>
      /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v
      ) || i18n.t("errorFrontEnd.invalidEmail"),
  ],
  inputPassword: [
    (v) => !!v || i18n.t("errorFrontEnd.requiredField"),
    (v) =>
      /^(?=.*[a-z])(?=.*[A-ZÀ-ȕ])(?=.*[0-9])(?=.*[\(\)\,\-\_\.\, !@#\$%\^&\*])/.test(
        v
      ) || i18n.t("errorFrontEnd.invalidPassword"),
    (v) => (v && v.length >= 8) || i18n.t("errorFrontEnd.atLeastCharacters"),
  ],
  inputPhoneNumber: [
    (v) => !!v || i18n.t("errorFrontEnd.requiredField"),
    (v) => /^(0|\\+33)[0-9]{9}$/.test(v) || i18n.t("errorFrontEnd.phoneNumber"),
  ],
};
